import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { discoveries } from '../../data/discoveries';
import { pricing } from '../../lib/pricing';

/** A small teaser of the kinds of questions waiting in other worlds. */
export function DiscoverNext() {
  return <section aria-labelledby="discover-heading" className="mt-16 md:mt-20" data-id="element-144" data-mp="cq8dc68va4ba">
      <h2 id="discover-heading" className="text-center font-display text-[28px] leading-tight tracking-tight text-ink md:text-[36px]" data-id="element-145" data-mp="3l6bio5cibgwg">
        What will they discover next?
      </h2>

      <ul className="mx-auto mt-8 grid max-w-[420px] gap-4 md:max-w-none md:grid-cols-3 md:gap-6" data-id="element-146" data-mp="3v47s8spsq3sg">
        {discoveries.map(item => <li key={item.topic} data-id="element-147" data-mp="3q4lf0j9ywnjn">
            <Link to={item.href} className="group flex h-full items-center gap-4 rounded-[24px] bg-white p-3 shadow-card transition-transform duration-200 ease-out hover:-translate-y-1 md:flex-col md:items-stretch md:gap-0" data-id="element-148" data-mp="3q7r8sbtjkdlp">
              <div className="w-[96px] shrink-0 rounded-[18px] bg-cream-field p-1.5 md:w-full md:p-3" data-id="element-149" data-mp="gs08taxnrm1e">
                <img src={item.art.src} alt={item.art.alt} loading="lazy" decoding="async" width={item.art.width} height={item.art.height} className="aspect-square w-full object-contain" data-id="element-150" data-mp="lq1s9wyzxnde" />
              </div>
              <div className="min-w-0 md:px-2 md:pb-3 md:pt-4" data-id="element-151" data-mp="30vemod27lyg">
                <p className="inline-flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-152" data-mp="2z0v9ehfs1wh">
                  <span aria-hidden="true" className="h-2 w-2 rounded-full bg-coral" data-id="element-153" data-mp="bt6u5f6mxozn" />
                  {item.topic}
                </p>
                <p className="mt-1 font-display text-[19px] leading-snug text-ink md:text-[21px]" data-id="element-154" data-mp="3bfvkhr5b9ns3">{item.question}</p>
              </div>
            </Link>
          </li>)}
      </ul>

      <p className="mt-7 text-center" data-id="element-155" data-mp="mna1w99lsgh3">
        <Link to="/worlds" className="group inline-flex items-center gap-2 rounded-lg font-display text-[18px] text-ink underline decoration-coral decoration-[3px] underline-offset-[6px]" data-id="element-156" data-mp="mlyv00kv2slr">
          Explore all {pricing.worldCount} worlds
          <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-157" data-mp="rg334n5v56of" />
        </Link>
      </p>
    </section>;
}